import app from 'flarum/common/app';
import registryJson from '../../../../resources/video-providers.json';
import { parseVideoUrl as parse, buildEmbedSrc as embed, buildWatchUrl as watch, buildThumbnailUrl as thumbnail, isValidVideoId as valid } from './parse';
/** The same registry the server builds its tag from. */
export const VIDEO_PROVIDERS = registryJson.providers;

/**
 * Whether embedding is switched on, and for which providers.
 *
 * 🚨 Read at USE time, never at module load: `app.forum` does not exist yet
 * when an initializer's module is evaluated.
 */
export function videoEmbedsEnabled() {
  return app.forum?.attribute('scribeVideoEmbeds') !== false;
}
export function videoProviderEnabled(provider) {
  if (!videoEmbedsEnabled()) return false;
  const off = app.forum?.attribute('scribeVideoOff') || [];
  return Object.prototype.hasOwnProperty.call(VIDEO_PROVIDERS, provider) && !off.includes(provider);
}

/** A pasted or typed URL, as an embeddable video — only for providers that are on. */
export function videoFromUrl(url) {
  return parse(VIDEO_PROVIDERS, url, videoProviderEnabled);
}

/** Recognised by the registry at all, whatever the admin has switched off. */
export function anyVideoFromUrl(url) {
  return parse(VIDEO_PROVIDERS, url);
}
export const isValidVideo = (provider, id) => valid(VIDEO_PROVIDERS, provider, id);
export const embedSrc = (ref, host) => embed(VIDEO_PROVIDERS, ref, host);
export const watchUrl = ref => watch(VIDEO_PROVIDERS, ref);
export const thumbnailUrl = ref => thumbnail(VIDEO_PROVIDERS, ref);

/** The name shown on a poster and in "Watch on …": the company, not the format. */
export function videoBrand(provider) {
  const def = VIDEO_PROVIDERS[provider];
  return def ? def.brand ?? def.name : provider;
}

/** "16:9" → "16x9", the suffix of the Scribe-video--r* class the stylesheet sizes by. */
export function videoRatioClass(provider) {
  return 'Scribe-video--r' + (VIDEO_PROVIDERS[provider]?.aspect ?? '16:9').replace(':', 'x');
}
flarum.reg.add('ernestdefoe-scribe', 'common/video/providers', { VIDEO_PROVIDERS: VIDEO_PROVIDERS,videoEmbedsEnabled: videoEmbedsEnabled,videoProviderEnabled: videoProviderEnabled,videoFromUrl: videoFromUrl,anyVideoFromUrl: anyVideoFromUrl,isValidVideo: isValidVideo,embedSrc: embedSrc,watchUrl: watchUrl,thumbnailUrl: thumbnailUrl,videoBrand: videoBrand,videoRatioClass: videoRatioClass, });